import { createTheme } from "@mui/material"


export const theme = createTheme({
  palette: {
    primary: {main: "#087E8B", light: "#50aebb", dark: "#00515e"},
    secondary: {main: "#FF5A5F", light: "#ff8e8c", dark: "#c62035"}
  }
})
